import { useEffect, useState, useCallback, useMemo } from "react";
import { useTranslation } from 'react-i18next';
import { useUIConfig } from "../Context";
import Toolbar from "../../../../controls/Toolbar";
import { CSS_LABEL } from "./css";
import RenderParams from "./RenderParams";


const ObjectComponent = ({
    label,
    description,
    keys,
    initialValue,
    overridesValue,
    disabled,
    onChange,
    onReset,
    path
}) => {
    const [translate] = useTranslation();
    const { edit, getInitialValue, reset, saveChanges, getOverridesValue } = useUIConfig();
    const [data, setData] = useState({});
    const [expanded, setExpanded] = useState(true);

    const directOnChange = useCallback((_, key, value) => {
        edit(path, key, value);
    }, [edit, path]);

    const renderToolbar = useMemo(() => <div className="border-accenture border-bottom">
        <Toolbar
            buttons={[
                {
                    name: 'ArrowDropDown',
                    hidden: !expanded,
                    onClick: () => setExpanded(!expanded)
                },

                {
                    name: 'ArrowLeft',
                    hidden: expanded,
                    onClick: () => setExpanded(!expanded)
                }
            ]}
            heading={label}
            tooltip={description}
            buttonTooltip={false}
            className='h6'
        />
    </div>, [label, description, expanded]);

    useEffect(() => {
        if (!initialValue) {
            setData({});
            return;
        }
        setData(initialValue);
    }, [keys, initialValue]);

    return <>
        {renderToolbar}
        {expanded &&
            <div className="bg-body p-3 pt-1 border-1 border border-top-0">
                {keys.length === 0 && <label>{translate("OTM_EMPTY_OBJECT")}</label>}
                <RenderParams
                    params={keys.map(key => ({
                        ...key,
                        initialValue: key.initialValue || getInitialValue(data[key.name], key.defaultValue, key.type),
                        overridesValue: getOverridesValue(overridesValue, key.name)
                    }))}
                    disabled={disabled}
                    currentPath={path}
                    updateCallback={path.includes(CSS_LABEL) ? onChange : directOnChange}
                    resetCallback={(paramName) => { if (path.includes(CSS_LABEL)) { onReset(paramName, path); } else { reset(path, paramName); saveChanges(); } }} />
            </div>
        }
    </>
}

export default ObjectComponent;